import React from 'react';

const GenreSelector = ({ 
  label = 'Genre', 
  genre, 
  genresList, 
  onChange, 
  onSelect,
  placeholder = 'Select genre',
  className = ''
}) => {
  return (
    <div className={`dash-form-group ${className}`}>
      <label>{label}</label>
      <div className="dropdown dash-form-dropdown">
        <input 
          type="text" 
          className='dash-form-input' 
          placeholder={placeholder} 
          data-bs-toggle="dropdown" 
          aria-expanded="false"
          value={genre}
          onChange={(e) => onChange(e)}
        />
        <ul className="dropdown-menu">
          {genresList.map((item, i) => (
            <li key={i} onClick={() => onSelect(item)}>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default GenreSelector; 